export default "__VITE_ASSET__DdmbCrQN__"